module.exports = __webpack_public_path__ + "img/shadow_arrow.c4bdb89.png";